export const FeatureFlagActionType = {
  INITIALIZE_FLAGS: 'INITIALIZE_FLAGS',
  SET_FLAGS: 'SET_FLAGS',
  SET_TRAITS: 'SET_TRAITS',
};

export const FEATURE_FLAG_KEYS = [
  'tx_analytics_email_table',
  'tx_analytics_sms_table',
  'tx_ao_notifications',
  'tx_ca_custom_module',
  'tx_context-data-queue-v2',
  'tx_demo',
  'tx_design_and_code_content',
  'tx_enable_experience_settings_in_actions_header',
  'tx_enable_touchpoint_editor',
  'tx_es1_link_visible',
  'tx_filters',
  'tx_flow_canvas_controls',
  'tx_flow_layered_layout',
  'tx_flow_multiple_contents',
  'tx_flow_v2',
  'tx_folders',
  'tx_journey_template_visible_to_flybits',
  'tx_labels',
  'tx_maker_checker',
  'tx_merchant_portal',
  'tx_opendome',
  'tx_sandbox',
  'tx_show_template_library_banner',
  'tx_template_library_modal',
  'tx_standalone_slideouts',
  'tx_theme_settings',
  'tx_zone_module_label_to_content',
  'tx_custom_analytics_enhancements',
  'tx_email_sms_custom_analytics_enabled',
  'tx_live_analytics',
] as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

export interface FeatureFlagState {
  isInitialized: boolean;
  flags: Partial<Record<FeatureFlagKey, boolean>>;
  traits: Record<string, unknown>;
}
